/**
 * Service color definitions for charts, badges, and analytics.
 * Each service has a primary color and a lighter background variant.
 * These match the analytic-* colors defined in tailwind.config.js.
 */

export interface ServiceColor {
    color: string
    bg: string
    text: string
    primary: string
    secondary: string
}

export const SERVICE_COLORS: Record<string, ServiceColor> = {
    cdn: {
        color: '#FF6E00',
        bg: '#FF6E00',
        text: '#FFFFFF',
        primary: '#FF6E00',
        secondary: '#F5821E',
    },
    vnis: {
        color: '#00009B',
        bg: '#00009B',
        text: '#FFFFFF',
        primary: '#00009B',
        secondary: '#0A19C8',
    },
    cloud: {
        color: '#AFD25A',
        bg: '#AFD25A',
        text: '#FFFFFF',
        primary: '#AFD25A',
        secondary: '#05A0C3',
    },
}

const FALLBACK_COLOR: ServiceColor = {
    color: '#6B7280',
    bg: '#6B7280',
    text: '#FFFFFF',
    primary: '#6B7280',
    secondary: '#9CA3AF',
}

/** Get service color by slug, falls back to neutral gray */
export const getServiceColor = (serviceSlug: string): ServiceColor =>
    SERVICE_COLORS[serviceSlug] || FALLBACK_COLOR
